import DOMPurify from 'dompurify';

// Configure DOMPurify to allow safe HTML tags and attributes
const ALLOWED_TAGS = ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'span', 'div', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tr', 'td', 'th', 'thead', 'tbody', 'img'];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'class', 'style', 'src', 'alt', 'width', 'height'];

/**
 * Sanitize HTML string to prevent XSS attacks.
 * Allows safe formatting tags while stripping dangerous content.
 */
export function sanitizeHtml(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
  });
}

/**
 * Create a safe dangerouslySetInnerHTML object.
 * Usage: <div {...safeInnerHtml(htmlString)} />
 */
export function safeInnerHtml(dirty) {
  return { dangerouslySetInnerHTML: { __html: sanitizeHtml(dirty) } };
}
